<template>
    <div>
        <p>
            <span class="has-text-primary"
                >{{ $t("shared-file.fileName") }}:
            </span>
            {{ file.fileName }}
        </p>
        <p>
            <span class="has-text-primary">
                {{ $t("shared-file.count-signatures") }}:
            </span>
            {{ signaturesCount }}
        </p>
        <p v-if="signaturesCount > 0">
            <span class="has-text-primary">
                {{ $t("shared-file.signers") }}:
            </span>
            {{ signers }}
        </p>
        <p class="has-text-centered mt-1">
            <button class="button" @click="downloadFile">
                <Icon family="fa" name="fa-cloud-download-alt" />
            </button>
        </p>
    </div>
</template>

<script>
const backendApiUrl = process.env.VUE_APP_BACKEND_API_URL;

export default {
    name: "shared-file",
    props: {
        file: {
            type: Object,
            required: true,
        },
    },
    computed: {
        signaturesCount() {
            let signatures = this.file.signatures;
            if (signatures === null || signatures === undefined) {
                return 0;
            }
            return signatures.length;
        },
        signers() {
            if (this.signaturesCount === 0) {
                return "";
            }
            return this.file.signatures
                .map((s) => {
                    return s.user.name;
                })
                .join(", ");
        },
    },
    methods: {
        downloadFile() {
            window.open(
                `${backendApiUrl}api/files/share/${this.file.id}`,
                "_blank"
            );
        },
    },
};
</script>